import React from 'react';

import AppBar from '~/components/AppBar';
import { useGoBack } from '~/hooks/url';

type Props = React.ComponentProps<typeof AppBar>;

export default function BaseAppBar(props: Props) {
  const goBack = useGoBack();
  return <AppBar onLeftClick={goBack} {...props} />;
}
